module.exports = __webpack_public_path__ + "img/img_guide.02e9d5d3.png";